export class OLLayerUtility {
    /**
     * 获取所有图层（包含图层组中的图层）
     * @param {*} mapLayers 
     */
    static getLayers(mapLayers) {
        let layers = new Array();

        let tempMapLayer = null;
        let tempGroupLayers = null;

        for (let tempIndex = 0; tempIndex < mapLayers.length; tempIndex++) {

            tempMapLayer = mapLayers[tempIndex];
            if (tempMapLayer instanceof ol.layer.Group) {
                tempGroupLayers = tempMapLayer.getLayers().getArray();
                for (let tempLayerIndex = 0; tempLayerIndex < tempGroupLayers.length; tempLayerIndex++) {
                    if (tempGroupLayers[tempLayerIndex]
                        && tempGroupLayers[tempLayerIndex] instanceof ol.layer.Base) {
                        layers.push(tempGroupLayers[tempLayerIndex]);
                    }
                }
            }
            else if (tempMapLayer instanceof ol.layer.Base) {
                layers.push(tempMapLayer);
            }
        }

        return layers;
    }

    static findByLayerAttribute(mapLayers, layerAttriFieldName, layerAttriFieldValue) {
        let findLayer = null;


        let tempMapLayer = null;
        let tempGroupLayers = null;
        let tempGroupLayer = null;
        let tempLayerAttriValue = null;
        for (let tempIndex = 0; tempIndex < mapLayers.length; tempIndex++) {

            tempMapLayer = mapLayers[tempIndex];
            if (tempMapLayer instanceof ol.layer.Group) {
                tempGroupLayers = tempMapLayer.getLayers().getArray();
                for (let tempLayerIndex = 0; tempLayerIndex < tempGroupLayers.length; tempLayerIndex++) {
                    tempGroupLayer = tempGroupLayers[tempLayerIndex];
                    if (tempGroupLayer
                        && tempGroupLayer instanceof ol.layer.Base) {
                        tempLayerAttriValue = tempGroupLayer.get(layerAttriFieldName);
                        if (tempLayerAttriValue && tempLayerAttriValue == layerAttriFieldValue) {
                            findLayer = tempGroupLayer;
                            break;
                        }
                    }
                }
            }
            else if (tempMapLayer instanceof ol.layer.Base) {
                tempLayerAttriValue = tempMapLayer.get(layerAttriFieldName);
                if (tempLayerAttriValue && tempLayerAttriValue == layerAttriFieldValue) {
                    findLayer = tempMapLayer;
                    break;
                }
            }
        }

        return findLayer;
    }




}